import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex-field-group" }
const _hoisted_2 = { class: "flex-field-group" }

import { AddressTypeModel } from '@src/view_models/AddressTypeModel';
import { useStore } from 'vuex';
import { useAddressTypeModel } from '@src/components/pages/donation_form/composables/useAddressTypeModel';
import type { AddressFormData, AddressValidity } from '@src/view_models/Address';
import TextField from '@src/components/shared/form_fields/TextField.vue';
import { computed, onBeforeMount, ref, watch } from 'vue';
import CityAutocompleteField from '@src/components/shared/form_fields/CityAutocompleteField.vue';
import CountryAutocompleteField from '@src/components/shared/form_fields/CountryAutocompleteField.vue';
import StreetAutocompleteField from '@src/components/shared/form_fields/StreetAutocompleteField.vue';
import type { Country } from '@src/view_models/Country';
import { Validity } from '@src/view_models/Validity';
import CheckboxField from '@src/components/shared/form_fields/CheckboxField.vue';

interface Props {
	formData: AddressFormData;
	showError: AddressValidity;
	countries: Country[];
	postCodeValidation: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'AddressFields',
  props: {
    formData: {},
    showError: {},
    countries: {},
    postCodeValidation: {}
  },
  emits: [ 'field-changed' ],
  setup(__props: any, { emit: __emit }) {


const props = __props;
const emit = __emit;

const store = useStore();
const addressType = useAddressTypeModel( store );

const showAddressTypeError = computed( () => store.getters[ 'address/addressTypeIsInvalid' ] );
const countryWasRestored = ref<boolean>( false );

const isCompany = ref<boolean>( addressType.value === AddressTypeModel.COMPANY_WITH_CONTACT );

const onCountryFieldChanged = ( country: Country | undefined ) => {
	if ( country ) {
		props.formData.postcode.pattern = country.postCodeValidation;
	} else {
		props.formData.postcode.pattern = props.postCodeValidation;
	}

	emit( 'field-changed', 'country' );

	if ( props.formData.postcode.value !== '' ) {
		emit( 'field-changed', 'postcode' );
	}
};

onBeforeMount( () => {
	countryWasRestored.value = store.state.address.validity.country === Validity.RESTORED;
} );

watch( isCompany, ( newValue: boolean ) => {
	addressType.value = newValue ? AddressTypeModel.COMPANY_WITH_CONTACT : AddressTypeModel.PERSON;
} );


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(CheckboxField, {
      modelValue: isCompany.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((isCompany).value = $event)),
      name: "is-company",
      id: "address-form-is-company",
      "input-id": "is-company",
      "error-message": _ctx.$t( 'donation_form_section_address_error' ),
      "show-error": showAddressTypeError.value
    }, {
      default: _withCtx(() => [
        _createElementVNode("span", null, _toDisplayString(_ctx.$t( 'donation_form_behalf_of_company' )), 1)
      ]),
      _: 1
    }, 8, ["modelValue", "error-message", "show-error"]),
    (isCompany.value)
      ? (_openBlock(), _createBlock(TextField, {
          key: 0,
          name: "companyName",
          id: "address-form-company-name",
          "input-id": "company-name",
          modelValue: __props.formData.companyName.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((__props.formData.companyName.value) = $event)),
          "show-error": __props.showError.companyName,
          "error-message": _ctx.$t( 'donation_form_companyname_error' ),
          autocomplete: "organization",
          label: _ctx.$t( 'donation_form_companyname_label' ),
          placeholder: _ctx.$t( 'donation_form_companyname_placeholder' ),
          onFieldChanged: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('field-changed', 'companyName')))
        }, null, 8, ["modelValue", "show-error", "error-message", "label", "placeholder"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(CountryAutocompleteField, {
        modelValue: __props.formData.country.value,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((__props.formData.country.value) = $event)),
        id: "address-form-country",
        "input-id": "country",
        "scroll-target-id": "address-form-country",
        countries: __props.countries,
        "was-restored": countryWasRestored.value,
        "show-error": __props.showError.country,
        onFieldChanged: onCountryFieldChanged
      }, null, 8, ["modelValue", "countries", "was-restored", "show-error"]),
      _createVNode(TextField, {
        name: "postcode",
        id: "address-form-post-code",
        class: "flex-field-group__mini-field",
        "input-id": "post-code",
        modelValue: __props.formData.postcode.value,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((__props.formData.postcode.value) = $event)),
        "show-error": __props.showError.postcode,
        "error-message": _ctx.$t('donation_form_zip_error'),
        autocomplete: "postal-code",
        label: _ctx.$t( 'donation_form_zip_label' ),
        placeholder: _ctx.$t( 'donation_form_zip_placeholder' ),
        "placeholder-warning": "donation_form_zip_placeholder_warning",
        onFieldChanged: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('field-changed', 'postcode')))
      }, null, 8, ["modelValue", "show-error", "error-message", "label", "placeholder"]),
      _createVNode(CityAutocompleteField, {
        modelValue: __props.formData.city.value,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((__props.formData.city.value) = $event)),
        id: "address-form-city",
        "input-id": "city",
        "scroll-target-id": "address-form-city",
        "show-error": __props.showError.city,
        label: _ctx.$t( 'donation_form_city_label' ),
        "error-message": _ctx.$t( 'donation_form_city_error' ),
        postcode: __props.formData.postcode.value,
        onFieldChanged: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$emit('field-changed', 'city' )))
      }, null, 8, ["modelValue", "show-error", "label", "error-message", "postcode"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(StreetAutocompleteField, {
        id: "address-form-street",
        "input-id-street-name": "street",
        "input-id-building-number": "building-number",
        "is-inline": true,
        "scroll-target-id": "address-form-street",
        modelValue: __props.formData.street.value,
        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((__props.formData.street.value) = $event)),
        postcode: __props.formData.postcode.value,
        "show-error": __props.showError.street,
        onFieldChanged: _cache[9] || (_cache[9] = ($event: any) => (_ctx.$emit('field-changed', 'street' )))
      }, null, 8, ["modelValue", "postcode", "show-error"])
    ])
  ], 64))
}
}

})